module.exports = __webpack_public_path__ + "img/grow_market.2b86d200.svg";